export var PillVariantType;
(function (PillVariantType) {
    PillVariantType["REGULAR"] = "REGULAR";
    PillVariantType["ROUNDED"] = "ROUNDED";
    PillVariantType["DROPDOWN"] = "DROPDOWN";
    PillVariantType["SEGMENTED_CONTROL"] = "SEGMENTED_CONTROL";
})(PillVariantType || (PillVariantType = {}));
//# sourceMappingURL=pillVariantType.js.map